export const MIN_COMMISSION = 0;
export const MAX_COMMISSION = 100;

export const isCommissionValueValid = (value: number): boolean => value >= MIN_COMMISSION && value <= MAX_COMMISSION;
